export default store => store && store.state.auth.user;
